import React, { useEffect, useState } from "react";
import Layout, { PageHeader, Surface, StatusPill } from "@/components/Layout";
import { api } from "@/lib/api";

const fmt$ = (v) => `$${Number(v || 0).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;

export default function Transactions() {
  const [items, setItems] = useState([]);
  const [merchants, setMerchants] = useState([]);
  const [merchantId, setMerchantId] = useState("");

  useEffect(() => { api.get("/admin/merchants").then((r) => setMerchants(r.data.items)); }, []);
  useEffect(() => {
    const q = merchantId ? `?merchant_id=${merchantId}&limit=300` : "?limit=300";
    api.get(`/admin/transactions${q}`).then((r) => setItems(r.data.items));
  }, [merchantId]);

  const byId = Object.fromEntries(merchants.map(m => [m.id, m.company_name]));

  return (
    <Layout>
      <div className="p-6 lg:p-10" data-testid="transactions-page">
        <PageHeader title="Transactions" subtitle="Live ledger across all issued cards." />

        <Surface className="p-3 mb-4 flex items-center gap-3">
          <span className="text-[10px] uppercase tracking-[0.05em] font-semibold text-zinc-500">Merchant</span>
          <select
            data-testid="tx-merchant-filter"
            value={merchantId}
            onChange={(e) => setMerchantId(e.target.value)}
            className="h-8 text-xs px-2 border border-zinc-200 rounded-sm bg-white focus:ring-1 focus:ring-zinc-900 focus:border-zinc-900 outline-none"
          >
            <option value="">All</option>
            {merchants.map(m => <option key={m.id} value={m.id}>{m.company_name}</option>)}
          </select>
          <div className="ml-auto text-xs text-zinc-500">{items.length} txns</div>
        </Surface>

        <Surface className="overflow-hidden">
          <table className="w-full text-sm">
            <thead>
              <tr className="text-left text-[10px] uppercase tracking-[0.05em] font-semibold text-zinc-500 border-b border-zinc-100">
                <th className="px-5 py-3">When</th>
                <th className="px-5 py-3">Type</th>
                <th className="px-5 py-3">Merchant</th>
                <th className="px-5 py-3">POS / Origin</th>
                <th className="px-5 py-3">Card</th>
                <th className="px-5 py-3 text-right">Amount</th>
                <th className="px-5 py-3">Status</th>
              </tr>
            </thead>
            <tbody>
              {items.map((t) => (
                <tr key={t.id} className="border-b border-zinc-50">
                  <td className="px-5 py-3 text-xs font-mono text-zinc-500">{(t.created_at || "").slice(0, 19).replace("T", " ")}</td>
                  <td className="px-5 py-3"><span className="text-[10px] font-mono uppercase tracking-[0.05em] px-1.5 py-0.5 rounded-sm bg-zinc-100">{t.type}</span></td>
                  <td className="px-5 py-3 text-xs">{byId[t.merchant_id] || t.merchant_id.slice(0, 8)}</td>
                  <td className="px-5 py-3 text-xs">{t.merchant_name || "—"}</td>
                  <td className="px-5 py-3 font-mono text-xs">{t.card_id?.slice(0, 8)}…</td>
                  <td className="px-5 py-3 text-right font-mono tabular-nums">{fmt$(t.amount)}</td>
                  <td className="px-5 py-3"><StatusPill value={t.status} /></td>
                </tr>
              ))}
              {items.length === 0 && <tr><td colSpan={7} className="px-5 py-10 text-center text-xs text-zinc-500">No transactions yet.</td></tr>}
            </tbody>
          </table>
        </Surface>
      </div>
    </Layout>
  );
}
